import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./views/LandingPage";
import SiteHeader from "./components/SiteHeader";
import AppShell from "./components/AppShell";
import AppHomePage from "./views/AppHomePage";
import ChatbotPage from "./views/chatbotpage";
import SectionReportPage from "./views/SectionReportPage";
import BenchmarkPage from "./views/BenchmarkPage";
import CompanySearchPage from "./views/CompanySearchPage";
import ProfileSettingsPage from "./views/ProfileSettingsPage";
import BillingRedirectPage from "./views/BillingRedirectPage";
import ResetPasswordPage from "./views/ResetPasswordPage";
import LegalPage from "./views/LegalPage";
import AdminMyRoomPage from "./views/AdminMyRoomPage";
import vopFileUrl from "./legal/VOP.txt";
import gdprFileUrl from "./legal/gdpr.txt";
import cookiesFileUrl from "./legal/cookies.txt";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/footer";
import "./views/style/global.css";
import FinanalystV2Page from "./views/FinanalystV2Page";
import { BlogListPage, BlogPostPage } from "./views/BlogPages";
import { IndustryFactPage, IndustryIndexPage } from "./views/IndustryPages";
import AboutPage from "./views/AboutPage";
import NotFoundPage from "./views/NotFoundPage";

function App() {
  return (
    <AuthProvider>
      <Router>
        <SiteHeader />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/vop" element={<LegalPage title="Všeobecné obchodní podmínky (VOP)" fileUrl={vopFileUrl} />} />
          <Route path="/gdpr" element={<LegalPage title="Zásady ochrany osobních údajů (GDPR)" fileUrl={gdprFileUrl} />} />
          <Route path="/cookies" element={<LegalPage title="Zásady používání cookies" fileUrl={cookiesFileUrl} />} />
          <Route path="/myroom" element={<AdminMyRoomPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/obory" element={<IndustryIndexPage />} />
          <Route path="/obor/:slug" element={<IndustryFactPage />} />
          <Route path="/o-projektu" element={<AboutPage />} />
          <Route
            path="/profile-settings"
            element={(
              <ProtectedRoute>
                <BillingRedirectPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/app"
            element={(
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            )}
          >
            <Route path="home" element={<AppHomePage />} />
            <Route path="chatbot" element={<ChatbotPage />} />
            <Route path="vyhledani-firmy" element={<CompanySearchPage />} />
            <Route
              path="financni-analyza"
              element={(
                <ProtectedRoute>
                  <FinanalystV2Page />
                </ProtectedRoute>
              )}
            />
            <Route path="oborove-statistiky" element={<SectionReportPage />} />
            <Route path="benchmark-obory" element={<BenchmarkPage />} />
            <Route path="profile" element={<ProfileSettingsPage />} />
          </Route>
          <Route
            path="/chatbot"
            element={(
              <ProtectedRoute>
                <ChatbotPage />
              </ProtectedRoute>
            )}
          />
          <Route path="/oborove-statistiky/:obor?" element={<SectionReportPage />} />
          <Route path="/benchmark-obory/:ukazatel?/:obor?" element={<BenchmarkPage />} />
          <Route
            path="/vyhledani-firmy"
            element={(
              <ProtectedRoute>
                <CompanySearchPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/financni-analyza"
            element={(
              <ProtectedRoute>
                <FinanalystV2Page />
              </ProtectedRoute>
            )}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </Router>
    </AuthProvider>
  );
}

export default App;
